import React from 'react';
import { Container, Row } from 'reactstrap';
import OfaDailyPerformance from './components/OfaDailyPerformance';

export default function OrderPerformanceIndex() {
  return (
    <Container className="dashboard">
      <Row>
        <OfaDailyPerformance />
      </Row>
    </Container>
  );
}
